// JavaScript Document
//components/configuration/standard/forms/Override.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
//import FormGroup from '@material-ui/core/FormGroup';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
import Setting from '../daysettings/Setting';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap: "wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
	advancedContentVertical: {
		display: "flex",
		alignItems:"stretch",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap"
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function Override(props) {
  	const classes = useStyles();
	//inherited variables
  	const {id, sign, config, speed, threshold, maxspeed, dim, mode, enable, onChange} = props;
	//locally stored/copied variables
	const [cid, setCid] = React.useState(0);
	//local state varialbes user will change
	const [settings, setSettings] = React.useState({
		speed: 25,
		threshold: 25,
		maxspeed: 35,
		op: 1
	});
	const [dimming, setDimming] = React.useState(99);
	const [enabled, setEnabled] = React.useState(false);
	
	//Local constant for maximum value
	const max = 99;
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== id 
			//updated from server
			//|| loadedToken != token
		) {
			setCid(id);
			setSettings({
				speed:speed || settings.speed,
				threshold: threshold || settings.threshold,
				maxspeed: maxspeed || settings.maxspeed,
				op : (mode === undefined || mode === null ? settings.op : mode)
			});
			setDimming(dim);
			setEnabled(enable ? true : false);
			
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Handle update parent if onChange is provided
	const handleUpdateParent = (newSettings, newDim, newEnable) => {
		let out = Object.assign({}, newSettings);
		out.dim = newDim;
		out.enable = newEnable;
		//redundant in case it's implemented differently
		out.mode = out.op;
		if(onChange){
			console.log('Updating parent');
			onChange(out);
		}
	}
	

	
	//handle change timing value
	const handleChangeDim = (e) => {
		//let setting = e.target.name;
		let value = parseInt(e.target.value);
		//let newWigwag = Object.assign({}, wigwag);
		//clean the value
		if(isNaN(value) || value < 0){
			value = 0;
		} else if(value > max){
			value = max;
		}
		setDimming(value);
		handleUpdateParent(settings, value, enabled);
	}
	
	//handle change enabled
	const handleChangeEnable = (e) => {
		let value = e.target.checked;
		setEnabled(value);
		handleUpdateParent(settings, dimming, value);
	}
	
	//handle setting changes
	const handleChangeSettings = (newSettings) => {
		setSettings(newSettings);
		handleUpdateParent(newSettings, dimming, enabled);
	}
	
	//display content (on or off based on enabled)
	const renderContent = () => {
		if(enabled){
			return (
				<CardContent className={classes.advancedContent}>
					<TextField 
						id="dimming" 
						name="dimming"
						label="Brightness"
						value={dimming.toString()} 
						className={classes.timingInput} 
						onChange={handleChangeDim}
						type="number" 
						inputProps={{min: '0', max:max.toString(), step:'5', style: {textAlign:'center'}}}
					/>
					<Setting sign={sign} config={config} settings={settings} onChange={handleChangeSettings} />
				</CardContent>
			);
		} else {
			return (
			<CardContent />
			);
		}
	}

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader 
				title="Override" 
				subheader={enabled? "Enabled" : "Disabled"}
				action={<Switch checked={enabled} onChange={handleChangeEnable} />}
			/>
				{renderContent()}
	  	</Card>
  );
}
